<!--
Copyright 2021 Carnegie Mellon University. All Rights Reserved.
Released under a MIT (SEI)-style license. See LICENSE.md in the project root for license information.
-->

@if (scenario !== undefined && scenario !== null) {
  <span>
    <div class="add-margin" (click)="$event.stopPropagation()">
      <div>
        <app-tasks
          [taskList]="taskList"
          [resultList]="resultList"
          [scenarioId]="scenario.id"
        [isEditable]="
          scenario.status === 'ready' || scenario.status === 'active'
        "
          [isExecutable]="scenario.status === 'active'"
          (taskListChanged)="refreshTaskList()"
          (deleteTaskRequested)="deleteTask($event)"
        ></app-tasks>
      </div>
    </div>
  </span>
}
